<template>
  <div class="vote_state_no-active-poll">
    <div class="duo-question">
      <span :style="{color:poll.jsStyle.questionColor}">{{question.texts[lang]}}</span>
    </div>
    <div class="duo-answers">
      <div
        class="answer"
        v-for="(answer, index) in answers"
        :key="index"
        :style="{flex:statsPercent(answer, 50), backgroundColor:getAnswerColor(poll, index)}"
      >
        <img :src="answer.image" class="mb-4" alt />
        <span
          class="text"
          :style="{color: invertColor(getAnswerColor(poll, index))}"
        >{{answer.texts[lang]}}</span>
        <div class="stats">
          <span class="percent" :style="{color: invertColor(getAnswerColor(poll, index))}">
            {{statsPercent(answer, 0)}}
            <i>%</i>
          </span>
          <!-- <span class="users-votes">{{answer.voteCount}}<i class="material-icons">person</i></span> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CommonMixin from '../mixins/common.js';

export default {
  name: 'vote-duo',
  props: { ...CommonMixin.props },
  computed: {
    ...mapGetters({ lang: 'getInputLanguage' }),
    ...CommonMixin.computed,
    statsPercent() {
      return (answer, startAt = 50) => {
        return this.answerPercent(answer) || startAt;
      };
    }
  },
  methods: {
    ...CommonMixin.methods
  }
};
</script>
<style lang="scss" scoped>
question_card {
  margin-bottom: 50px;
}

.answer {
  list-style: none;
}

/* Duo Wall */
html {
  overflow: hidden;
}

.duo-question {
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.3);
  z-index: 200;
  position: absolute;
  background: #fff;
  font-size: 30px;
  letter-spacing: 5px;
  text-transform: uppercase;
  font-weight: bold;

  .triangle {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 30px 30px 0 30px;
    border-color: #ffffff transparent transparent transparent;
    position: absolute;
    top: 100px;
    left: calc(20% - 30px);
  }
}

.duo-answers {
  display: flex;
  height: 100%;
  height: 100vh;

  .answer {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s ease-out;
    flex-direction: column;

    img {
      width: 100%;
      max-width: 300px;
      object-fit: cover;
      border-radius: 50%;
    }

    span {
      display: block;
      width: 100%;
      text-align: center;

      &.text {
        background: rgba(0, 0, 0, 0.1);
        padding: 10px;
        font-size: 50px;
      }
    }

    .stats {
      display: flex;
      flex-direction: row;
      background: rgba(0, 0, 0, 0.05);
      width: 100%;
      font-size: 30px;

      span {
        &.percent {
          i {
            font-size: 75%;
            font-style: inherit;
          }
        }

        &.users-votes {
          i {
            vertical-align: middle;
            font-size: inherit;
          }
        }
      }
    }
  }
}
</style>
